module.exports = __webpack_public_path__ + "img/logo.e36dd018.jpg";